import { useTenantInfo } from "@/helpers/hooks";
import KnowledgeCatalogDetailsV1 from "./KnowledgeCatalogDetailsV1";
import KnowledgeCatalogDetailsV2 from "./KnowledgeCatalogDetailsV2";

const KnowledgeCatalogDetails = () => {
  const { enableKnowledgeEngine } = useTenantInfo();
  if (enableKnowledgeEngine) {
    return <KnowledgeCatalogDetailsV2 />;
  }
  return <KnowledgeCatalogDetailsV1 />;
};

export default KnowledgeCatalogDetails;
